<div class="container-fluid">

  <div class="container">
  <blockquote class="blockquote text-center">
    <i class="bi bi-box-arrow-right"></i>
    <p class="mb-0">Thank You!</p>
    <br />
    <footer class="blockquote-footer">You have now been logged-out from the application.
      <br>
      <p>Redirecting in {{ seconds }}</p>
    </footer>
  </blockquote>
</div>
</div>
